/*
  Base file for example file in component.
  Meant to show what the component is used for
  in conjunction with the './html'

  add path to the src/index.js to be able to see it:
  ex. 'import "./components/notificationsView";'
*/

import run from "../../utilities/run";
import render from "../../utilities/render";
import _ from "underscore";
import $ from "jquery";
import {setElementsFromScope} from "../../utilities/selectorHelpers";
import {createPreventDefault, isBlank} from '../../utilities/general';
import WidgetEngine from "../../components/WidgetEngine/index.js";
import {sampleAlertsFilterData, sampleFilterList} from "./stores/sampleFilterData.js";
import {statusOptions} from "./stores/statusOptions.js";
import html from "./html/notificationsHtml/notifications.html";
import QuickBtnGroup from "../../components/QuickBtnGroup/QuickBtnGroup";
import SubmitModalFlow from "../../components/SubmitModalFlow/SubmitModalFlow";
const modalHtml = require("../../sharedHtml/modal.html");

const viewTogglerHtml = require('./html/notificationsHtml/viewToggler.html');
const exportModalBodyHtml = require('./html/notificationsHtml/exportModalBody.html');

const iconColTemplateHtml = require('../../components/WidgetEngine/html/globalHtml/iconColTemplate.html');
const descripColTemplateHtml = require('../../components/WidgetEngine/html/globalHtml/descripColTemplate.html');
const dateColTemplateHtml = require('../../components/WidgetEngine/html/globalHtml/dateColTemplate.html');
const channelColTemplateHtml = require('../../components/WidgetEngine/html/globalHtml/channelColTemplate.html');
const pillColTemplateHtml = require('../../components/WidgetEngine/html/globalHtml/pillColTemplate.html');
const actionColTemplateHtml = require('../../components/WidgetEngine/html/globalHtml/actionColTemplate.html');
const actionLinkTemplateHtml = require('../../components/WidgetEngine/html/globalHtml/actionLinkTemplate.html');

const targetSelector = "#view-notification-form";
// const targetSelector = "#p_p_id_channels_WAR_hcportlet_";

const pillsMap = {
  "Action Needed": "q-pill-blue",
  "In Progress": "q-pill-white-and-blue",
  "Dismissed": "q-pill-white-and-grey"
}

const iconsMap = {
  Order: "fa-shopping-basket",
  ASN: "fa-exchange",
  RMA: "fa-reply",
  WorkOrder: "fa-reply",
  Product: "fa-reply",
  Inventory: "fa-reply",
  Facilities: "fa-reply"
}

// use this to render description link with sku link to details based on status type
const descriptionStringsMap = {
  Order: "Order {%= detailsLink %}.",
  ASN: "ASN {%= detailsLink %}.",
  RMA: "RMA {%= detailsLink %}.",
  WorkOrder: "Item {%= detailsLink %}.",
  Product: "Item {%= detailsLink %}.",
  Inventory: "Item {%= detailsLink %}.",
  Facilities: "Item {%= detailsLink %}."
}

const elementsMap = {
  exportBtn: ".export-widgets",
  manageBtn: ".manage-btn",
  markInProgressBtn: '.markInProgress',
  markDismissedBtn: '.markDismissed',
  viewDetailsBtn: '.viewDetails'
}

const elementsModalMap = {
  exportTypeToggler: ".export-type-toggler",
  exportDateRangeStart: ".export-date-range-start",
  exportDateRangeEnd: ".export-date-range-end",
  exportSubmitBtn: ".export-btn"
}

function getNotificationOnPageLoad(){
  //Show Notification bell on the portal header
  let element = $('.top-notification-section');
  if(element.length){
    AUI().use('aui-base','liferay-portlet-url','aui-node', function(A) {
      const plid = element.find("a").data("plid");
      var notificationURL = Liferay.PortletURL.createResourceURL();
      notificationURL.setResourceId('getNotificationCount');
      notificationURL.setPortletId('notificationsubscription_WAR_commerceportlet');
      notificationURL.setPlid(plid);
      $.ajax({
       url: notificationURL.toString(),
       type: "POST",
       dataType: "json",
       success: function (data) {
         const response = data.notificationObject;
         if(_.has(response, "paging")) {
           element.show();
           element.find(".notification-count").text(response.paging.count);
           if(response.paging.count > 0){
             element.find(".notification-count").addClass("q-pretty-pill-tag q-ppt-green");
           }
           var notificationDetailURL = Liferay.PortletURL.createRenderURL();
           notificationDetailURL.setPortletId('notificationsubscription_WAR_commerceportlet');
           notificationDetailURL.setParameter('action', 'viewNotification');
           notificationDetailURL.setPlid(plid);
           element.find("a").attr("href", notificationDetailURL);
         }
       },
       error: function(data){
       }
      });
    });
  }
}

$(document).ready(function (){
  //Invoke this function on page load
  getNotificationOnPageLoad();
});

run(targetSelector, ()=>{
  var form = $(targetSelector);
  const PAGE_LIMIT = 10;
  const getNotificationsUrl = form.data('get-notifications-url');
  const getManageNotificationsUrl = form.data('manage-notification-preference-url');
  const updateDisplayStatusUrl = form.data('update-status-url');
  const generateExportUrl = form.data('generate-export-url');
  const notificationObject = form.data('notification-list');
  const newNotificationObject = form.data('new-notification-list');
  const subscribedObjectTypes = form.data('object-type-list');
  const filterData = form.data('filter-data');
  const moreData = notificationObject.paging.count > PAGE_LIMIT;
  let fromDateTime = form.data('from-date');
  let toDateTime = form.data('to-date');
  let lastToDateTime = notificationObject.paging.lastToDateTime;
  let notificationsAlertList = {};
  notificationsAlertList.data = notificationObject.exceptionLog; // this is required as widget engine needs data attribute for list

  const orderDetailsPageUrl = form.data('order-page-url');
  const asnDetailsPageUrl = form.data('asn-page-url'); // For future use

  const urlMap = {
    Order: orderDetailsPageUrl
  }

  // Required to Load Stub
  const outerEl = $(html);
  $(targetSelector).html(outerEl);

  // START: Actual Code
  const els = {};
  const elsModal = {};
  let exportModal;

  // general setup for notifications view page here
  function init(){
    exampleWidgetEngine.init();

    generateModals();
    setElements();
    exportModalComponentsInit();
    bindElements();
    setLinks();
  }

  function setElements(){
    setElementsFromScope(els, elementsMap, outerEl);
    setElementsFromScope(elsModal, elementsModalMap, exportModal);
  }

  function bindElements(){
    els.exportBtn.click(createPreventDefault(showExportModal));
    $(document).on("click", elementsMap.markInProgressBtn, markInProgressAction);
    $(document).on("click", elementsMap.markDismissedBtn, markDismissedAction);
    $(document).on("click", elementsMap.viewDetailsBtn, viewDetailsBtnAction);
    $(document).on("click", elementsModalMap.exportSubmitBtn, exportSubmitBtnAction);
  }

  function showExportModal(){
    exportModal.modal("show");
  }

  function markInProgressAction(e) {
    e.preventDefault();
    if(!$(this).hasClass('disabled')) {
      updateDisplayStatus("In Progress", "", $(this).data("id"), $(this).data("url"));
    }    
  }

  function markDismissedAction(e) {
    e.preventDefault();
    if(!$(this).hasClass('disabled')) {
      updateDisplayStatus("Dismissed", "Viewed", $(this).data("id"), $(this).data("url"));  
    }    
  }

  function viewDetailsBtnAction(e) {
    e.preventDefault();
    $(this).attr('target', '_blank');
    window.open($(this).data('url'));
  }

  function exportSubmitBtnAction(e) {
    e.preventDefault();
    let filterRequest = {};
    filterRequest.displayStatus = ["Action Needed", "In Progress", "Dismissed"]; // to be converted to array for service
    if(elsModal.exportDateRangeStart.val().length > 0){
      filterRequest.fromDateTime = elsModal.exportDateRangeStart.val();
    }
    if(elsModal.exportDateRangeEnd.val().length > 0){
      filterRequest.toDateTime = elsModal.exportDateRangeEnd.val();
    }
    filterRequest.objectType = subscribedObjectTypes;
    var url = generateExportUrl+"&notificationType=Alerts&filterRequest="+JSON.stringify(filterRequest);
    window.open(url);
    exportModal.modal("hide");
  }

  function updateDisplayStatus(displayStatus, status, id, url) {
    const submitModal = new SubmitModalFlow();
    submitModal.init();
    let exceptionLogData = {
      ["exceptionLogId"]: id + "",
      ["displayStatus"]: displayStatus
    };

    if(!isBlank(status)) {
      exceptionLogData.status = status;
    }

    $.ajax({
      url: url,
      type: "POST",
      dataType: "json",
      data: exceptionLogData,
      beforeSend: function () {
        submitModal.showLoadingModal();
      },
      complete: function () {
        submitModal.hideAllModals();
      },
      success: function (data, textStatus, jqXHR) {
        exampleWidgetEngine.refreshAfterActionClicked();
      },
      error: function(){
        // server will show an error modal on exceptions
      }
    });
  }

  function setLinks() {
    els.manageBtn.prop("href", getManageNotificationsUrl);
  }

  function generateModals(){
    exportModal = $(render(modalHtml,
      {
        title: 'Export Notifications',
        leftAlignTitle: true,
        modalDialogClass: "q-modal-dialog-500",
        body: render(exportModalBodyHtml),
        topCloseBtn: true,
        autoHideTop: true,
        footerBtns: `
          <a href="#" class="base-btn v2-btn purple-btn modal-auto-hide">Cancel</a> <a href="#" class="base-btn purple-btn export-btn">Export</a>
        `
      }
    ));

    outerEl.append(exportModal);
  }

  function exportModalComponentsInit(){
    const date = new Date();

    elsModal.exportDateRangeStart.datepicker({
      endDate: date,
      todayBtn: "linked",
      keyboardNavigation: false,
      autoclose: true
    }).on('changeDate', function (selected) {
        var minDate = new Date(selected.date.valueOf());
        elsModal.exportDateRangeEnd.datepicker('setStartDate', minDate);
    });

    elsModal.exportDateRangeEnd.datepicker({
      endDate: date,
      todayBtn: "linked",
      keyboardNavigation: false,
      autoclose: true
    }).on('changeDate', function (selected) {
        var maxDate = new Date(selected.date.valueOf());
        elsModal.exportDateRangeStart.datepicker('setEndDate', maxDate);
    });

    const exportTypeBtnGroup = new QuickBtnGroup(elsModal.exportTypeToggler, {
      distributeWidth: true
    });
    exportTypeBtnGroup.init();
  }
  // end of general setup for notifications view page here

  // begin component initialization here - portal dev will need to pass render functions to component to render columns
  const exampleWidgetEngine = new WidgetEngine({
    // REQUIRED - Set a target element
    target: $(".widget-engine-target"),
    data: notificationsAlertList,
    hasViewToggler: true,
    viewToggler: renderViewToggler(),
    viewTogglerDataCountTarget: ".notifications-count",
    filterList: sampleFilterList,
    // groupBy: "status",
    header: "Notifications Alerts",
    filterBy: "",

    // NOTE: set this to whichever on page load
    filterListActive: "all",

    widgetFilters: {
      data: filterData,
      // NOTE: these paramas are optional, if you need more properties on dropdown that appears on responsive view
      // filterDropdownName: "",
      // filterDropdownId: "",
      // filterDropdownPlaceholder: ""
    },
    filterModal: {
      // REQUIRED: Sets title of modal
      title: "Filter Alerts",
      // REQUIRED: Sets unique part of subtitle string.
      widgetType: "alerts"
    },

    columns: [
      {
        data: "icon",
        render: renderAlertIconCol,
      },
      {
        data: "title",
        render: renderAlertDescriptCol,
      },
      {
        data: "exceptionTime",
        render: renderAlertDateCol,
      },
      {
        data: "displayStatus",
        render: renderAlertPillCol,
      },
      {
        data: "displayStatus",
        render: renderAlertActionsCol,
      },
    ],

    // boolean to check whether there's still data to load from database
    moreData: moreData,

    onFetch: function() {
      let filters = exampleWidgetEngine.generateData();
      let filterRequest = {};
      if(filters.filterLinkData === "all") {
        filterRequest.displayStatus = ["Action Needed", "In Progress"]; // to be converted to array for service
      } else {
        filterRequest.displayStatus = [filters.filterLinkData];  // to be converted to array for service
      }
      filterRequest.fromDateTime = fromDateTime;
      filterRequest.toDateTime = lastToDateTime;
      filterRequest.objectType = subscribedObjectTypes;// if user selected alert types from filter, these values will be replaced in controller

      const data = {
          ["filterRequest"]: JSON.stringify(filterRequest),
          ["searchCriteria"]: JSON.stringify(filters.searchCriteria),
          ["loadMore"]: true
      };

      $.ajax({
        url: getNotificationsUrl,
        type: "POST",
        dataType: "json",
        data: data,
        beforeSend: function () {
          exampleWidgetEngine.showLoadingBtn();
        },
        complete: function () {
          exampleWidgetEngine.hideLoadingBtn();
        },
        success: function (data, textStatus, jqXHR) {
          const response = data.notificationObject;
          if(_.has(data.notificationObject, "exceptionLog") && response.exceptionLog.length > 0) {
            exampleWidgetEngine.appendNewData(response.exceptionLog);
            exampleWidgetEngine.filterListActive = filters.filterLinkData;
            exampleWidgetEngine.setFilterLinkActive(exampleWidgetEngine.filterListActive);
            exampleWidgetEngine.validateForMoreData(response.paging.count > PAGE_LIMIT);
            lastToDateTime = response.paging.lastToDateTime;
          } else {
            exampleWidgetEngine.filterListActive = filters.filterLinkData;
            exampleWidgetEngine.setFilterLinkActive(exampleWidgetEngine.filterListActive);
            exampleWidgetEngine.validateForMoreData(false);
          }
        },
        error: function(){
          // server will show an error modal on exceptions
        }
      });
    },

    // NOTE: different from onFetch because fetch just appends to bottom of page. Filter needs to replace data
    onFilter: function() {
      const submitModal = new SubmitModalFlow();
      submitModal.init();
      let filters = exampleWidgetEngine.generateData();
      let filterRequest = {};
      if(filters.filterLinkData === "all") {
        filterRequest.displayStatus = ["Action Needed", "In Progress"]; // to be converted to array for service
      } else {
        filterRequest.displayStatus = [filters.filterLinkData];  // to be converted to array for service
      }
      filterRequest.fromDateTime = fromDateTime;
      filterRequest.toDateTime = toDateTime;
      filterRequest.objectType = subscribedObjectTypes; // if user selected alert types from filter, these values will be replaced in controller

      const data = {
          ["filterRequest"]: JSON.stringify(filterRequest),
          ["searchCriteria"]: JSON.stringify(filters.searchCriteria),
          ["loadMore"]: false
      };

      $.ajax({
        url: getNotificationsUrl,
        type: "POST",
        dataType: "json",
        data: data,
        beforeSend: function () {
          submitModal.showLoadingModal();
        },
        complete: function () {
          submitModal.hideAllModals();
        },
        success: function (data, textStatus, jqXHR) {
          const response = data.notificationObject;
          if(_.has(data.notificationObject, "exceptionLog") && response.exceptionLog.length > 0) {
            fromDateTime = data.fromDateTime;
            toDateTime = data.toDateTime;
            exampleWidgetEngine.setNewData(response.exceptionLog);
            exampleWidgetEngine.filterListActive = filters.filterLinkData;
            exampleWidgetEngine.setFilterLinkActive(exampleWidgetEngine.filterListActive);
            exampleWidgetEngine.validateForMoreData(response.paging.count > PAGE_LIMIT);
            lastToDateTime = response.paging.lastToDateTime;
          } else {
            fromDateTime = data.fromDateTime;
            toDateTime = data.toDateTime;
            exampleWidgetEngine.setNewData([]); //set empty data
            exampleWidgetEngine.filterListActive = filters.filterLinkData;
            exampleWidgetEngine.setFilterLinkActive(exampleWidgetEngine.filterListActive);
            exampleWidgetEngine.validateForMoreData(false);
          }
        },
        error: function(){
          // server will show an error modal on exceptions
        }
      });
    },

    // onViewToggleCallback: function(){
    //   //NOTE: this is for an upcoming story. I will add more here when implementing upcoming story
    // }
  });

  // NOTE: start of render functions portal dev will need to pass to component for columns, links, and filter
  function renderViewToggler(){
    let newAlertCount = 0;
    if(_.has(newNotificationObject, "paging")) {
      newAlertCount = newNotificationObject.paging.count;
    }
    return render(viewTogglerHtml, {
      alertNumber: newAlertCount + ' New'
    })
  }

  function renderAlertIconCol(data, key, rowData){
    return render(
      iconColTemplateHtml, {
        icon: iconsMap[rowData.objectType],
        classWidth: "q-col-fix-40"
      }
    )
  }

  function renderAlertDescriptCol(data, key, rowData){
    return render(
      descripColTemplateHtml, {
        title: rowData.title,
        description: getDescriptionString(rowData),
        classWidth: "q-col-6"
      }
    )
  }

  function getDescriptionString(rowInfo){
    // NOTE: no reason to create new variables, since we just need to return the one after manipulating and rendering it
    let description = descriptionStringsMap[rowInfo.objectType];
    let url = getDetailsUrl(rowInfo);
    description = render(
      description,
      {
        detailsLink: `<a target="_blank" href="${url}" target="_blank">${rowInfo.objectId}</a>` || ""
      }
    )

    return description + "<br>" + getDescription(rowInfo.description);
  }

  function getDescription(description) {
    if(isBlank(description) || description == 'null') {
      return "";
    } else {
      return description;
    }
  }

  function renderAlertDateCol(data, key, rowData){
    return render(
      dateColTemplateHtml, {
        date: moment(rowData.exceptionTime).format('MM/DD/YYYY'),
        status: rowData.status,
        classWidth: "q-col-2"
      }
    )
  }

  function renderAlertPillCol(data, key, rowData){
    return render(
      pillColTemplateHtml, {
        pillColor: pillsMap[rowData.displayStatus],
        pillText: getPillText(rowData),
        classWidth: "q-col-fix-155"
      }
    )
  }

  function getPillText(rowInfo){
    if(rowInfo.displayStatus === "In Progress"){
      return `${rowInfo.displayStatus}: ${rowInfo.exceptionOwnerId}`
    } else {
      return rowInfo.displayStatus
    }
  }

  function renderAlertActionsCol(data, key, rowData){
    return render(
      actionColTemplateHtml, {
        alertActionList: getActionList(rowData),
        classWidth: "q-col-fix-80"
      }
    );
  }

  function getActionList(rowData){
    // NOTE: Mike K recommended that I add default set of actions in callback in case they pass something in that doesn't exist
    // But since portal dev will be rendering this for time being, perhaps they can handle the clicks for these action links?
    let statusObj = statusOptions[rowData.displayStatus];
    $.each(statusObj, function(i, v){
      v.id = rowData.exceptionLogId;
      v.url = getActionUrl(v, rowData);
    });
    const linksArray = _(statusObj).map(renderAlertActionsLink).join("");
    return linksArray;
  }

  function renderAlertActionsLink(actionLinkObj){
    return render(
      actionLinkTemplateHtml,
      //  NOTE: you can add more params here if you need, such as href
      {
        title: actionLinkObj.title,
        cls: actionLinkObj.cls,
        icon: actionLinkObj.icon,
        disabled: actionLinkObj.disabled,
        id: actionLinkObj.id,
        url: actionLinkObj.url
      }
    )
  }

  function getActionUrl(actionLinkObj, rowData) {
    let url = "";

    if(actionLinkObj.cls === 'viewDetails') { // create details page url
      url = getDetailsUrl(rowData);
    } else { // use update display status url for mark InPorgres and Dismissed
      url = updateDisplayStatusUrl;
    }

    return url;
  }

  function getDetailsUrl(rowData) {
      let url = urlMap[rowData.objectType];

      if(rowData.objectType === 'Order') {
        url = url + '&orderId=' + rowData.objectId;
      } else if(rowData.objectType === 'ASN') {
        url = url + '&asnId=' + rowData.objectId;
      }

      return url;
  }

  // NOTE: call functon to initialize component and page here
  init();
});



// WEBPACK FOOTER //
// ./src/pages/notificationAlerts/notificationsStub.js